"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var SportsOffer_styles_1 = __importDefault(require("./SportsOffer.styles"));
var PrimaryControls_1 = __importDefault(require("../PrimaryControls/PrimaryControls"));
var SecondaryControls_1 = __importDefault(require("../SecondaryControls/SecondaryControls"));
var algoliasearch_1 = __importDefault(require("algoliasearch"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var SportsOfferTable_1 = __importDefault(require("../SportsOfferTable/SportsOfferTable"));
var loginState_1 = require("../../../types/loginState");
var SportsOffer = function (_a) {
    var loggedIn = _a.loggedIn, firstTimeLogin = _a.firstTimeLogin, clinicSupplier = _a.clinicSupplier;
    var _b = react_1.useState({ client: null, index: null }), state = _b[0], setState = _b[1];
    var initialSearchState = JSON.parse(localStorage.getItem('searchState'));
    var _c = react_1.useState(initialSearchState ? initialSearchState : {}), searchState = _c[0], setSearchState = _c[1];
    var onSearchStateChange = function (updatedSearchState) {
        localStorage.setItem('searchState', JSON.stringify(updatedSearchState));
        setSearchState(updatedSearchState);
    };
    react_1.useEffect(function () {
        // The settings endpoint requires an authenticated session. Skip the
        // request entirely for guests so it doesn't fire (and fail with a
        // 401) on the way to the /login redirect below.
        if (loggedIn !== loginState_1.LOGGEDIN) {
            return;
        }
        // Get the algolia credentials from the server
        var getSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                axios_1.default.request({
                    url: '/api/algolia/settings',
                    transformResponse: function (response) {
                        return JSON.parse(response);
                    },
                }).then(function (response) {
                    setState({
                        client: algoliasearch_1.default(response.data.app_id, response.data.search_key),
                        index: response.data.index,
                    });
                });
                return [2 /*return*/];
            });
        }); };
        getSettings();
    }, [loggedIn]);
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/login' });
    }
    if (clinicSupplier && firstTimeLogin) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/availability' });
    }
    if (clinicSupplier) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: '/agenda' });
    }
    return (react_1.default.createElement(SportsOffer_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" }, state.client && state.index &&
                react_1.default.createElement(react_instantsearch_dom_1.InstantSearch, { searchClient: state.client, indexName: state.index, searchState: searchState, onSearchStateChange: onSearchStateChange, refresh: true },
                    react_1.default.createElement(react_instantsearch_dom_1.ScrollTo, null,
                        react_1.default.createElement(PrimaryControls_1.default, null),
                        react_1.default.createElement(SportsOfferTable_1.default, null),
                        react_1.default.createElement(SecondaryControls_1.default, null)))))));
};
exports.default = SportsOffer;
